import { DashboardPage } from "./dashboard";

export const Dashboard = DashboardPage;
